// import { ID, Response } from "../../../../../_metronic/helpers"

import {ID, Response} from '../../../../../../_metronic/helpers'

export type District = {
  id?: ID
  name?: string
  label?: string
  value?: ID
  district_name?: string
  avatar?: string
  email?: string
  position?: string
  status?: string
  role?: string
  last_login?: string
  two_steps?: boolean
  joined_day?: string
  online?: boolean
  initials?: {
    label: string
    state: string
  }
}

export type DistrictsQueryResponse = Response<Array<District>>

export const initialDistrict: District = {
  avatar: 'avatars/300-6.jpg',
  position: 'Art Director',
  role: 'Administrator',
  name: '',
  email: '',
}
